import { defineStore } from 'pinia';
import { ExternalIdListItem } from '@/models/external-id-list/external-id-list-item.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { ExternalIdListFilter } from '@/models/external-id-list/external-id-list-filter.model';

interface SegmentExternalIdListState {
  segmentExternalIdList: ExternalIdListItem[];
  isSegmentExternalListLoading: boolean;
}

export const useSegmentExternalIdListStore = defineStore('SegmentExternalListStore', {
  state: (): SegmentExternalIdListState => ({
    segmentExternalIdList: [],
    isSegmentExternalListLoading: false,
  }),
  actions: {
    setSegmentExternalListLoading(isLoading: boolean): void {
      this.isSegmentExternalListLoading = isLoading;
    },
    getSegmentExternalList(filterList: ExternalIdListFilter = {}): Promise<ExternalIdListItem[]> {
      this.setSegmentExternalListLoading(true);

      return api.segmentExternat.getSegmentExternalIdListRequest.perform({ filterList })
        .then((data: ExternalIdListItem[]) => {
          this.segmentExternalIdList = data;

          return data;
        })
        .catch((error) => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setSegmentExternalListLoading(false);
        });
    },
  },
});
